import { TipoIdentificacion } from "./tipo-identificacion";

export class CuentaContable{
    public constructor(
        public id: string = "",
        public tipo_cuenta_id: string = "",
        public nivel_cuenta_id: string = "",
        public padre_id: string = null,
        
        public nombre:string = "",
        public codigo:string = "",
        public descripcion:string = "",
        public is_auxiliar:boolean = null,
        public isPadre:boolean = null,
        public empresa_id: string = "",
        public usuario_id:string = null,
        public status: string = "",
        

        // public cuentaPadre: CuentaContable = new CuentaContable(),


    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/cuenta-contable.ts